import {Navigate} from "react-router-dom";
import {MarketingComponent} from "../components/MarketingComponent.tsx";
import {useAuth} from "../../../hooks/useAuth.ts";

export const PublicHomePage = () => {

    // FNP-1932: same test RequireAuth uses. Keying on the user's email let a
    // user with no session tokens bounce between / and /dashboard forever.
    const {status} = useAuth();

    if (status === 'authenticated') {
        return <Navigate to={'/dashboard'} replace/>;
    } else {
        return <MarketingComponent/>;
    }


};
